import { render, staticRenderFns } from "./LegacyConsignments.vue?vue&type=template&id=41ac5af8&"
import script from "./LegacyConsignments.vue?vue&type=script&lang=js&"
export * from "./LegacyConsignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports